import { useCallback } from 'react';
import quarkusApi from '../../../../api/quarkusApi';

export function usePrescriptionToPrint() {
  const fetchPrescriptionToPrint = useCallback(
    (patientId, prescriptionId) =>
      quarkusApi.get(`/prescriptions/${patientId}/${prescriptionId}/print`, {
        headers: { Authorization: sessionStorage.getItem('token') },
      }),
    [],
  );

  return { fetchPrescriptionToPrint };
}
